<template>
  <div>
    <GroupHeader :width="460" :left="60" :top="479" :title="$t('Monitoring1025.hydroData')" />
    <div class="hydro-container" :style="{ width: width + 'px', height: height + 'px', left: left + 'px', top: top + 'px' }">
      <!-- 两个波浪进度图 -->
      <div id="waveChart" class="wave-chart"></div>
      <div class="wave-grade-container">
        <span class="grade-info">{{ waveHeightGrade }}</span>
        <span>{{ $t('Monitoring1025.waveGrade') }}</span>
      </div>
      <div id="tideChart" class="tide-chart"></div>
      <div class="tide-status-conatiner">
        <span class="tide-status">{{ currentVelocity }}</span>
        <span class="small">m/s</span>
        <span>{{ $t('Monitoring1025.surfaceCurrent') }}</span>
      </div>
      <!-- 折线图 -->
      <ul class="line-cat-container">
        <li @click="changeLineDataIndex(0)">
          <div :class="{ box: selectedCat != 0, 'box1-selected': selectedCat == 0 }"></div>
          <span :class="{ 'box1-text-selected': selectedCat == 0 }">{{ $t('Monitoring1025.waveHeight') }}</span>
        </li>
        <li @click="changeLineDataIndex(1)">
          <div :class="{ box: selectedCat != 1, 'box2-selected': selectedCat == 1 }"></div>
          <span :class="{ 'box2-text-selected': selectedCat == 1 }">{{ $t('Monitoring1025.waveDirection') }}</span>
        </li>
        <li @click="changeLineDataIndex(2)">
          <div :class="{ box: selectedCat != 2, 'box3-selected': selectedCat == 2 }"></div>
          <span :class="{ 'box3-text-selected': selectedCat == 2 }">{{ $t('Monitoring1025.wavePeriod') }}</span>
        </li>
      </ul>
      <div id="lineChart" class="line-chart"></div>
      <!-- 信息 -->
      <div class="row row1">
        <div class="col">
          <img class="col-img" src="../../assets/images/1025/wave-height.png" />
          <div class="col-text-wrapper">
            <div class="col-no-text">
              {{ waveHeightStart }}.
              <span class="small">{{ waveHeightEnd }}</span>
              m
            </div>
            <div class="col-tip-text">{{ $t('Monitoring1025.waveHeight') }}</div>
          </div>
        </div>
        <div class="col">
          <img class="col-img" src="../../assets/images/1025/wave-direction.png" />
          <div class="col-text-wrapper">
            <div class="col-no-text">
              {{ waveDirectionStart }}.
              <span class="small">{{ waveDirectionEnd }}</span>
              °
            </div>
            <div class="col-tip-text">{{ $t('Monitoring1025.waveDirection') }}</div>
          </div>
        </div>
        <div class="col">
          <img class="col-img" src="../../assets/images/1025/wave-period.png" />
          <div class="col-text-wrapper">
            <div class="col-no-text">
              {{ wavePeroidStart }}.
              <span class="small">{{ wavePeriodEnd }}</span>
              S
            </div>
            <div class="col-tip-text">{{ $t('Monitoring1025.wavePeriod') }}</div>
          </div>
        </div>
      </div>
      <div class="row row2">
        <div class="col">
          <img class="col-img" src="../../assets/images/1025/temperature.png" />
          <div class="col-text-wrapper">
            <div class="col-no-text">
              {{ surfaceTemStart }}.
              <span class="small">{{ surfaceTemEnd }}</span>
              °C
            </div>
            <div class="col-tip-text">{{ $t('Monitoring1025.surfaceTemp') }}</div>
          </div>
        </div>
        <div class="col">
          <img class="col-img" src="../../assets/images/1025/velocity.png" />
          <div class="col-text-wrapper">
            <div class="col-no-text">
              {{ currentVelocityStart }}.
              <span class="small">{{ currentVelocityEnd }}</span>
              m/s
            </div>
            <div class="col-tip-text">{{ $t('Monitoring1025.currentVelocity') }}</div>
          </div>
        </div>
        <div class="col">
          <img class="col-img" src="../../assets/images/1025/direction.png" />
          <div class="col-text-wrapper">
            <div class="col-no-text">
              {{ currentDirectionStart }}.
              <span class="small">{{ currentDirectionEnd }}</span>
              °
            </div>
            <div class="col-tip-text">{{ $t('Monitoring1025.currentDirection') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GroupHeader from './GroupHeader.vue'
import * as echarts from 'echarts'
import 'echarts-liquidfill'

export default {
  props: {
    width: {
      type: Number,
      default: 460
    },
    height: {
      type: Number,
      default: 497
    },
    left: {
      type: Number,
      default: 60
    },
    top: {
      type: Number,
      default: 526
    },
    eqdata: {
      type: Object,
      default: null
    },
    waveData: {
      type: Array
    }
  },
  components: { GroupHeader },
  data() {
    return {
      waveChart: null,
      tideChart: null,
      lineChart: null,
      selectedCat: 0, // 左侧折线图的选择分类
      timeArrs: [],
      lineData: [],
      data1: [],
      data2: [],
      data3: []
    }
  },
  created() {
    this.lineColors = ['rgba(255, 220, 76, 1)', 'rgba(255, 151, 76, 1)', 'rgba(230, 90, 86, 1)']
    this.lineAreaColors = ['rgba(255, 220, 76, 0.4)', 'rgba(255, 151, 76, 0.4)', 'rgba(230, 90, 86, 0.4)']
  },
  watch: {
    waveData(newVal) {
      if (newVal != null && Array.isArray(newVal)) {
        let timeArrs = [],
          data1 = [],
          data2 = [],
          data3 = []
        for (let i = newVal.length - 1; i >= 0; i--) {
          let item = newVal[i]
          let mhs = item['时间'].split(' ')[1]
          timeArrs.push(mhs.substr(0, mhs.length - 3))
          data1.push(parseFloat(Number(item['1/3 Wave Height(m)']).toFixed(1)))
          data2.push(parseFloat(Number(item['Wave Direction(°)']).toFixed(0)))
          data3.push(parseFloat(Number(item['1/3 Wave Period(s)']).toFixed(1)))
        }
        this.timeArrs = timeArrs
        this.data1 = data1
        this.data2 = data2
        this.data3 = data3
        this.lineData = this.selectedCat == 0 ? this.data1 : this.selectedCat == 1 ? this.data2 : this.data3
        this.setLineChartOptions()
      }
    },
    selectedCat: {
      immediate: false,
      handler(val) {
        this.setLineChartOptions(val)
      }
    }
  },
  methods: {
    initChart() {
      this.waveChart = echarts.init(document.getElementById('waveChart'))
      // this.tideChart = echarts.init(document.getElementById('tideChart'))
      this.lineChart = echarts.init(document.getElementById('lineChart'))
      this.setWaveChartOptions()
      // this.setTideChartOptions()
      this.setLineChartOptions()
    },
    setWaveChartOptions() {
      let option = {
        series: [
          {
            type: 'liquidFill',
            data: [0.6, 0.6], // 多个波浪，数大在前，数小在后，避免遮挡（不透明情况下)。
            color: ['#294D99', '#156ACF', '#1598ED', '#45BDFF'],
            center: ['50%', '50%'], // 球心到左/上边界的距离 百分数 或者 px（其他单位也按px计算）
            radius: '100%', // 调节球的大小，百分数或者px
            amplitude: '7%', // 波浪幅度，振幅大小， 0为平面
            waveLength: '70%',
            phase: 'auto',
            period: 'auto',
            direction: 'right',
            shape: 'circle', // 形状设置 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'
            waveAnimation: true, // 开启或关闭波浪动画
            animationEasing: 'linear',
            animationEasingUpdate: 'linear',
            animationDuration: 1000, // 第一次波浪升起来时的动画时长； 设为0后直接切换
            animationDurationUpdate: 1000, // data数据变动时波浪升起或下降的动画时长，数据变动后需调用mychart.setOption(option)
            outline: {
              show: false, // 默认显示，false不显示
              borderDistance: 0
            },
            backgroundStyle: {
              color: '#071E34', // 水球背景色
              borderWidth: 1, // 水球内部圆形的边框宽度， 默认是没有的
              borderColor: '#62a2cd' // 设置了边框颜色才能看见边框； #f2c52a
            },

            itemStyle: {
              opacity: 0.95, // 波浪颜色透明度
              shadowBlur: 50, // 波浪边缘的阴影
              shadowColor: 'rgba(0, 0, 0, 0.4)'
            },
            label: {
              show: false
            },
            emphasis: {
              // 鼠标悬停效果设置位置
              itemStyle: {
                opacity: 0.8, // 波浪填充色的hover style 的透明度， 鼠标放在波浪上的透明度
                color: '#585a99'
              }
            }
          }
        ],
        tooltip: {
          show: false // 鼠标放上显示数据
        }
      }
      this.waveChart.setOption(option)
    },
    setTideChartOptions() {
      let option = {
        series: [
          {
            type: 'liquidFill',
            data: [0.6, 0.6], // 多个波浪，数大在前，数小在后，避免遮挡（不透明情况下)。
            color: ['#6d6313', '#6d6313'],
            center: ['50%', '50%'], // 球心到左/上边界的距离 百分数 或者 px（其他单位也按px计算）
            radius: '100%', // 调节球的大小，百分数或者px
            amplitude: '7%', // 波浪幅度，振幅大小， 0为平面
            waveLength: '70%',
            phase: 'auto',
            period: 'auto',
            direction: 'right',
            shape: 'circle', // 形状设置 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'
            waveAnimation: true, // 开启或关闭波浪动画
            animationEasing: 'linear',
            animationEasingUpdate: 'linear',
            animationDuration: 1000, // 第一次波浪升起来时的动画时长； 设为0后直接切换
            animationDurationUpdate: 1000, // data数据变动时波浪升起或下降的动画时长，数据变动后需调用mychart.setOption(option)
            outline: {
              show: false, // 默认显示，false不显示
              borderDistance: 0
            },
            backgroundStyle: {
              color: '#342E07', // 水球背景色
              borderWidth: 1, // 水球内部圆形的边框宽度， 默认是没有的
              borderColor: '#f2c52a' // 设置了边框颜色才能看见边框；
            },
            itemStyle: {
              opacity: 0.95, // 波浪颜色透明度
              shadowBlur: 50, // 波浪边缘的阴影
              shadowColor: 'rgba(0, 0, 0, 0.4)'
            },
            label: {
              show: false
            },
            emphasis: {
              // 鼠标悬停效果设置位置
              itemStyle: {
                opacity: 0.8, // 波浪填充色的hover style 的透明度， 鼠标放在波浪上的透明度
                color: '#585a99'
              }
            }
          }
        ],
        tooltip: {
          show: false // 鼠标放上显示数据
        }
      }
      this.tideChart.setOption(option)
    },
    setLineChartOptions() {
      let maxNumber = parseInt(Math.max(...this.lineData))
      if (maxNumber == 0) {
        maxNumber = parseFloat(Math.max(...this.lineData)) + 0.1
      } else if (maxNumber < 5) {
        maxNumber += 1.0
      } else if (maxNumber < 10) {
        maxNumber += 2.0
      } else if (maxNumber < 50) {
        maxNumber = Math.ceil(maxNumber / 10) * 10
      } else if (maxNumber < 500) {
        maxNumber = Math.ceil(maxNumber / 100) * 100
      } else if (maxNumber > 1000) {
        maxNumber = Math.ceil(maxNumber / 100) * 100
      }

      const maxDataArr = new Array(this.lineData.length).fill(maxNumber)
      let lineColor = this.lineColors[this.selectedCat]
      let lineAreaColor = this.lineAreaColors[this.selectedCat]
      let option = {
        grid: {
          top: '10%',
          bottom: '10%',
          right: '5%'
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.timeArrs,
          axisLabel: {
            textStyle: {
              color: '#7CC5F7',
              fontSize: 10,
              width: 2
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          max: maxNumber,
          axisLabel: {
            textStyle: {
              color: '#7CC5F7',
              fontSize: 10,
              width: 2
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(10, 45, 78, 0.5)'
            }
          }
        },
        series: [
          {
            type: 'bar',
            data: maxDataArr,
            barWidth: '80%', // Set the width of the bars
            itemStyle: {
              color: 'rgba(10, 45, 78, 0.5)'
            }
          },
          {
            data: this.lineData,
            type: 'line',
            areaStyle: {
              color: lineAreaColor
            },
            lineStyle: {
              color: lineColor
            },
            itemStyle: {
              color: lineColor
            },
            label: {
              show: true,
              position: 'top',
              color: lineColor
            }
          }
        ]
      }
      this.lineChart.setOption(option)
    },
    // 切换
    changeLineDataIndex(index) {
      switch (index) {
        case 0:
          this.selectedCat = 0
          this.lineData = this.data1
          break
        case 1:
          this.selectedCat = 1
          this.lineData = this.data2
          break
        case 2:
          this.selectedCat = 2
          this.lineData = this.data3
          break
        default:
          this.lineData = []
      }
      this.setLineChartOptions(this.lineChartData)
    },
    dataStart(obj, key) {
      if (obj == null) return '0'
      let data = obj[key]
      let index = data.indexOf('.')
      if (index != -1) {
        let str = data.substr(0, index)
        return str
      } else {
        return '0'
      }
    },
    dataEnd(obj, key) {
      if (obj == null) return '0'
      let data = obj[key]
      let index = data.indexOf('.')
      if (index != -1) {
        let str = data.substr(index + 1, 2)
        return str
      } else {
        return '0'
      }
    }
  },
  mounted() {
    this.initChart()
  },
  computed: {
    waveDirectionStart() {
      return this.dataStart(this.eqdata, 'Wave Direction(°)')
    },
    waveDirectionEnd() {
      return this.dataEnd(this.eqdata, 'Wave Direction(°)')
    },
    surfaceTemStart() {
      return this.dataStart(this.eqdata, window.guiyanaTempKey)
    },
    surfaceTemEnd() {
      return this.dataEnd(this.eqdata, window.guiyanaTempKey)
    },
    waveHeightStart() {
      return this.dataStart(this.eqdata, '1/3 Wave Height(m)')
    },
    waveHeightEnd() {
      return this.dataEnd(this.eqdata, '1/3 Wave Height(m)')
    },
    wavePeroidStart() {
      return this.dataStart(this.eqdata, '1/3 Wave Period(s)')
    },
    wavePeriodEnd() {
      return this.dataEnd(this.eqdata, '1/3 Wave Period(s)')
    },
    currentVelocityStart() {
      if (this.eqdata == null) return '0'
      let data = this.eqdata['Current Velocity 01(mm/s)']
      data = Number(data) / 1000 + ''
      let index = data.indexOf('.')
      if (index != -1) {
        let str = data.substr(0, index)
        return str
      } else {
        return '0'
      }
    },
    currentVelocityEnd() {
      if (this.eqdata == null) return '0'
      let data = this.eqdata['Current Velocity 01(mm/s)']
      data = Number(data) / 1000 + ''
      let index = data.indexOf('.')
      if (index != -1) {
        let str = data.substr(index + 1, 1)
        return str
      } else {
        return '0'
      }
    },
    currentDirectionStart() {
      if (this.eqdata == null) return '0'
      let data = this.eqdata['Current Direction 01(°)']
      data = Number(data) / 1000 + ''
      let index = data.indexOf('.')
      if (index != -1) {
        let str = data.substr(0, index)
        return str
      } else {
        return '0'
      }
    },
    currentDirectionEnd() {
      if (this.eqdata == null) return '0'
      let data = this.eqdata['Current Direction 01(°)']
      data = Number(data) / 1000 + ''
      let index = data.indexOf('.')
      if (index != -1) {
        let str = data.substr(index + 1, 2)
        return str
      } else {
        return '0'
      }
    },
    waveHeightGrade() {
      if (this.eqdata == null) return 'G0'
      let data = this.eqdata['1/3 Wave Height(m)']
      let number = Number(data)
      if (number < 0.1) {
        return 'G1'
      } else if (number >= 0.1 && number < 0.5) {
        return 'G2'
      } else if (number >= 0.5 && number < 1.3) {
        return 'G3'
      } else if (number >= 1.3 && number < 2.5) {
        return 'G4'
      } else if (number >= 2.5 && number < 4.0) {
        return 'G5'
      } else if (number >= 4.0 && number < 6.0) {
        return 'G6'
      } else if (number >= 6.0 && number < 9) {
        return 'G7'
      } else if (number >= 9 && number < 13.9) {
        return 'G8'
      } else {
        return 'G0'
      }
    },
    currentVelocity() {
      if (this.eqdata == null) return 'G0'
      let data = this.eqdata['Current Velocity 01(mm/s)']
      return (Number(data) / 1000).toFixed(1)
    }
  },
  destroyed() {
    if (this.waveChart) {
      this.waveChart.dispose()
      this.waveChart = null
    }
    if (this.tideChart) {
      this.tideChart.dispose()
      this.tideChart = null
    }
    if (this.lineChart) {
      this.lineChart.dispose()
      this.lineChart = null
    }
  }
}
</script>

<style lang="scss" scoped>
.hydro-container {
  position: absolute;
  background: rgba(23, 78, 128, 0.22);

  // 两个进度
  .wave-grade-container {
    position: absolute;
    left: 30px;
    top: 30px;
    width: 97px;
    height: 97px;
    border-radius: 97px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: Adobe Heiti Std;
    font-size: 11px;
    color: #ffffff;
    font-weight: bold;
    z-index: 40;

    .grade-info {
      font-weight: 400;
      font-size: 36px;
      color: #009fff;
      line-height: 23px;
      font-style: normal;
      margin: 8px 0;
    }
  }

  .wave-chart {
    position: absolute;
    left: 30px;
    top: 30px;
    width: 97px;
    height: 97px;
  }

  .tide-status-conatiner {
    position: absolute;
    left: 30px;
    top: 155px;
    width: 97px;
    height: 97px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: Adobe Heiti Std;
    font-size: 11px;
    color: #ffffff;
    font-weight: bold;
    z-index: 40;
    text-align: center;

    .tide-status {
      font-weight: 400;
      font-size: 24px;
      color: #7cc5f7;
      font-style: normal;
      margin: 8px 0 -4px 0;
      width: 97px;
      text-align: center;
    }
    .small {
      font-size: 12px;
      color: #7cc5f7;
      text-align: center;
      margin-bottom: 2px;
    }
  }

  .tide-chart {
    position: absolute;
    left: 30px;
    top: 155px;
    width: 97px;
    height: 97px;
    background-image: url('../../assets/images/1025/surface-current.png');
    background-size: 97px 97px;
  }

  // 折现
  .line-cat-container {
    position: absolute;
    left: 160px;
    top: 30px;
    width: 290px;
    height: 25px;
    z-index: 50;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    font-size: 10px;
    color: rgb(255, 255, 255, 0.6);

    li {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-right: 10px;
    }
    .box {
      width: 10px;
      height: 10px;
      border: 1px solid grey;
      margin-right: 6px;
    }

    .box1-selected {
      width: 10px;
      height: 10px;
      background: #ffcc00;
      border: 1px solid #ffcc00;
      margin-right: 6px;
    }

    .box1-text-selected {
      color: white;
    }

    .box2-selected {
      width: 10px;
      height: 10px;
      background: #ff974c;
      border: 1px solid #ff974c;
      margin-right: 6px;
    }

    .box2-text-selected {
      color: white;
    }

    .box3-selected {
      width: 10px;
      height: 10px;
      background: #e65a56;
      border: 1px solid #e65a56;
      margin-right: 6px;
    }

    .box3-text-selected {
      color: white;
    }
  }

  .line-chart {
    position: absolute;
    left: 150px;
    top: 55px;
    width: 300px;
    height: 205px;
  }

  // 数据
  .row {
    position: absolute;
    display: flex;
    z-index: 20;
    justify-content: space-between;
    height: 53px;
    width: 440px;
    z-index: 30;
  }

  .row1 {
    left: 10px;
    top: 296px;
  }

  .row2 {
    left: 10px;
    top: 379px;
  }

  .col {
    width: 140px;
    height: 53px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .col-img {
      width: 53px;
      height: 53px;
      display: inline-block;
      margin-right: 4px;
    }

    .col-text-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      height: 53px;

      .col-no-text {
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        font-style: italic;
        font-weight: bold;
        word-spacing: -6px;
        min-width: 80px;
        .small {
          text-align: center;
          font-size: 14px;
        }
      }

      .col-tip-text {
        font-size: 12px;
        color: #00f3fb;
        text-align: center;
        font-weight: bold;
      }
    }
  }
}
</style>
